import warningIcon from '@xero/xui-icon/icons/warning';
import { XUIBannerAction } from '@xero/xui/react/banner';
import externalIcon from '@xero/xui-icon/icons/external';
import XUIIcon from '@xero/xui/react/icon';
import { FC } from 'react';
import { translate } from '../../helpers/translate';
import InformationBanner from '../InformationBanner';

export interface IPendingCancellationBannerProps {
    bannerText: string;
    confirmText: string;
    headingText: string;
    subscriptionEndDate: string;
    integrationName: string;
    showExternalIcon: boolean;
    onManageSubscriptionClick: () => void;
}

const PendingCancellationBanner: FC<IPendingCancellationBannerProps> = (props) => {
    const { subscriptionEndDate, integrationName, onManageSubscriptionClick, bannerText, confirmText, headingText, showExternalIcon } =
        props;

    const qaHook = 'connected-pendingCancellation-confirm';

    return (
        <div className={'xui-padding-horizontal'}>
            <InformationBanner
                qaHook='connected-pendingCancellation-banner'
                bannerMessage={translate(bannerText, {
                    integrationName,
                    subscriptionEndDate,
                })}
                sentiment={'neutral'}
                displayCloseButton={false}
                action={
                    <div data-automationid={qaHook} data-testid={qaHook}>
                        <XUIBannerAction
                            onClick={onManageSubscriptionClick}
                        >{confirmText} {showExternalIcon ? <XUIIcon icon={externalIcon} /> : null}</XUIBannerAction>
                    </div>
                }
                header={
                    <>
                        <span className='xui-heading-medium pending-cancellation-banner-header'>
                            <XUIIcon icon={warningIcon} color='black' className='xui-margin-right-small' />
                            {headingText}
                        </span>
                    </>
                }
                displayWarningIcon={false}
            />
        </div>
    );
};

export default PendingCancellationBanner;
